import { render, staticRenderFns } from "./CustomAccordion.vue?vue&type=template&id=41334848&scoped=true&"
import script from "./CustomAccordion.vue?vue&type=script&lang=js&"
export * from "./CustomAccordion.vue?vue&type=script&lang=js&"
import style0 from "./CustomAccordion.vue?vue&type=style&index=0&id=41334848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41334848",
  null
  
)

export default component.exports